require('../modules/es.array.iterator');
require('../modules/es.string.iterator');
var isIterable = require('../internals/is-iterable');

module.exports = isIterable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/is-iterable.js
// module id = 673
// module chunks = 0 1